export default __webpack_public_path__ + "static/media/e-commerce-sm.0fb294fa.webp";